/**
 * Главный файл утилит для работы с AMO полями
 * Экспортирует функции из всех модулей для обратной совместимости
 */


import { 
    normalizeFieldName, 
    getAmoEnumDisplayValue,
    getAllAmoFields, 
    getAmoFieldType, 
    getCurrentAmoFieldValue, 
    getAmoFieldValueText 
} from './amoFieldsCore.js';

import { setAmoFieldValue, clearMultiselectField } from './amoFieldsSetter.js';
import { forceUpdateAmoFieldsValidation } from './amoFieldsSetterHelpers.js';
import { 
    debugAmoField, 
    debugMultiselectState, 
    debugMultiselectHTML, 
    testMultiselectSync, 
    testClearMultiselect 
} from './amoFieldsDebug.js';


export { 
    normalizeFieldName, 
    getAmoEnumDisplayValue,
    getAllAmoFields, 
    getAmoFieldType, 
    getCurrentAmoFieldValue, 
    getAmoFieldValueText,
    setAmoFieldValue,
    clearMultiselectField,
    forceUpdateAmoFieldsValidation,
    debugAmoField,
    debugMultiselectState,
    debugMultiselectHTML,
    testMultiselectSync,
    testClearMultiselect
};


if (typeof window !== 'undefined') {
    window.debugMultiselectState = debugMultiselectState;
    window.debugAmoField = debugAmoField;
    window.debugMultiselectHTML = debugMultiselectHTML;
    window.setAmoFieldValue = setAmoFieldValue;
    window.testMultiselectSync = testMultiselectSync;
    window.clearMultiselectField = clearMultiselectField;
    window.testClearMultiselect = testClearMultiselect;
}
